module.exports = __webpack_public_path__ + "static/media/vidaPrestamista.a6044e32.svg";